import { render } from "./OilResultRow.vue?vue&type=template&id=b9d593b2&scoped=true&ts=true"
import script from "./OilResultRow.vue?vue&type=script&lang=ts"
export * from "./OilResultRow.vue?vue&type=script&lang=ts"

import "./OilResultRow.vue?vue&type=style&index=0&id=b9d593b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d593b2"]])

export default __exports__